<script setup lang="ts">
import { URL_SEARCH } from '@tools/routes/routes';
import IconMagnifyingGlass from '@icons/ph_magnifying-glass.svg';
import { trans } from '@elements/translation.ts';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
</script>

<template>
  <a
    :href="URL_SEARCH"
    :class="[
      'rounded-full border border-solid border-gray',
      'bg-gray-lighter hover:bg-gray focus:bg-gray',
      'h-[40px] w-[256px]',
      'flex items-center gap-3',
      'px-3 py-2',
      'no-underline',
    ]"
  >
    <Icon
      :svg="IconMagnifyingGlass"
      width="24"
      height="24"
      fill="gray-darker"
    />

    <Typography
      variant="body-bold"
      color="gray-darker"
    >
      {{ trans('user_menu.top.search') }}
    </Typography>
  </a>
</template>
